<p-editor
  #editor
  class="editor-fill-height"
  (click)="$event.stopPropagation()"
  [(ngModel)]="note.note"
  [readonly]="!note.ownerId"
  [modules]="quillModules"
  (onTextChange)="textChanged()"
>
  <ng-template pTemplate="header">
    <span class="ql-formats">
      <select class="ql-size">
        <option value="small"></option>
        <option selected></option>
        <option value="large"></option>
      </select>
      <select class="ql-font">
        <option selected></option>
        <option value="serif"></option>
        <option value="monospace"></option>
      </select>
    </span>

    <span class="ql-formats">
      <button class="ql-bold"></button>
      <button class="ql-italic"></button>
      <button class="ql-underline"></button>
    </span>

    <span class="ql-formats">
      <button class="ql-list" value="ordered"></button>
      <button class="ql-list" value="bullet"></button>
    </span>

    <span class="ql-formats">
      <button class="ql-clean" value="bullet"></button>
    </span>

    <p-progressSpinner *ngIf="dirty" strokeWidth="3"></p-progressSpinner>
    <div *ngIf="!dirty" class="flex flex-column justify-content-center w-2rem" style="float: right; height: 24px">
      <i class="pi pi-check align-self-center text-color-secondary"></i>
    </div>
  </ng-template>
</p-editor>
